module.exports = __webpack_public_path__ + "static/img/ai-intelligence.22879d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/innovation/ai-intelligence.png
// module id = j+qL
// module chunks = 2